import { pickBy } from 'lodash';
import { Channel } from 'redux-saga';
import ISocketHandler from '../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../api/sockets/ISocketMessage';
import checkNullableValue from '../../../utils/checkNullableValue';
import {
  serializeTicket,
  serializeActiveTicketInfo,
} from '../../serializers/tickets';
import {
  WS_UPDATE_ACTIVE_TICKET,
  SET_ACTIVE_TICKET_INFO,
} from '../../actions/tickets';

class TicketChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  update(message: ISocketMessage): void {
    const ticket = serializeTicket(message.data);
    const updatedTicketFields = pickBy(ticket, checkNullableValue);

    this.socketChannel.put({
      type: WS_UPDATE_ACTIVE_TICKET,
      payload: { ticket: updatedTicketFields },
    });
  }

  create(): void {
    return undefined;
  }

  delete(): void {
    return undefined;
  }

  info(message: ISocketMessage): void {
    const info = serializeActiveTicketInfo(message.data);

    this.socketChannel.put({
      type: SET_ACTIVE_TICKET_INFO,
      payload: { info },
    });
  }
}

export default TicketChannelHandler;
